import { Box } from "@mui/material";
import { get } from "lodash";
import * as React from "react";
import { Controller } from "react-hook-form";
import Tabs from "../../Tabs";
import DataFormInput from "../DataFormInput";
import { formitMeta } from "../formit";
import { IInput } from "../types/dataForm/types";

export interface IInputTabs extends IInput {
  accept?: string;
  setValue?: any;
  type?: React.InputHTMLAttributes<unknown>["type"];
  minRows?: number;
  maxRows?: number;
  readonly?: boolean;
  size?: "medium" | "small";
  form: any;
  labelName: string;
  data: any;
  schema: any;
}

export default function InputTabs({
  name,
  form,
  labelName,
  data,
  schema,
}: IInputTabs) {
  const schemaMetas = Object.keys(schema?.fields).map((name) =>
    formitMeta(schema, name)
  );
  const { watch } = form;
  const tabRef: any = React.useRef();

  React.useEffect(() => {
    const subscription = watch((value: any, { name, type }: any) => {
      if (!name && !type && value?.languages) {
        // sadece ilk açılışta tetiklenmesi için bu kontrolü yapıyoruz.
        const form_languages = value?.languages;
        console.log("form_languages: ", form_languages);
        const isUpdate = value?.id;
        const languages = data;

        const ordered_languages = [] as any;

        if (isUpdate) {
          languages?.forEach((lang, index) => {
            const form_language = form_languages.find(
              (item) => item.id === lang.value
            );

            if (form_language) {
              ordered_languages[index] = form_language;
            } else {
              //ordered_languages[index] = { languageCode: lang.id }
            }
          });

          form.setValue("languages", ordered_languages);
          tabRef.current.handleChange(1);
          setTimeout(() => {
            tabRef.current.handleChange(0);
          }, 2);
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, data]);

  const tabs = () =>
    data?.map((item: any) => ({ label: get(item, labelName) }));

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Tabs onTabChange={() => {}} ref={tabRef} tabs={tabs()} value={"0"}>
          {tabs().map((lang: any, index: number) => (
            <Box key={index}>
              {schemaMetas.map((meta: any, i: number) => (
                <DataFormInput
                  key={i}
                  meta={meta}
                  form={form}
                  name={`${name}[${index}].${meta.name}`}
                />
              ))}
            </Box>
          ))}
        </Tabs>
      )}
    />
  );
}
